import classNames from 'classnames'
import React from 'react'
import RectLoader from '../rect-loader/index.jsx'

import './styles.scss'

const IconListLoader = ({ className, rows = 6 }) => {
  return (
    <div className={classNames('icon-list-loader', className)}>
      <For each="row" of={new Array(rows).fill(0, 0, rows)} index="index">
        <div key={`${index}`} className="icon-list-loader__row">
          <RectLoader width={16} height={16} />
          <RectLoader width={200} height={16} />
        </div>
      </For>
    </div>
  )
}

export default IconListLoader
